module.exports = __webpack_public_path__ + "static/img/detect04.5c6af2c.png";


//////////////////
// WEBPACK FOOTER
// ./src/module/technology/images/detect04.png
// module id = 578
// module chunks = 4